import {
  IOperation,
  IOperationChildcare,
  IOperationItem,
  IOperationReimbursementExpense,
  IOperationTopUp,
  IOperationVoucherExpense,
} from '@/common/integrations/menhir/employee/operations/operations.types';

export const isTopUpOperationItem = (operation: IOperationItem) =>
  operation.type === 'topup' || operation.type === 'deposit';

export const isExpenseOperationItem = (operation: IOperationItem) =>
  operation.type === 'benefit_expense';

export const isExpenseRejectedOperationItem = (operation: IOperationItem) =>
  operation.type === 'benefit_expense' &&
  operation.status === 'rejected' &&
  !operation.productSlug?.includes('reimbursement');

export const isVoucherExpenseOperationItem = (operation: IOperationItem) =>
  operation.type === 'benefit_expense' &&
  operation.categorySlug === 'meals' &&
  operation.productSlug === 'meal-voucher-card';

export const isReimbursementExpenseOperationItem = (
  operation: IOperationItem
) =>
  operation.type === 'benefit_expense' &&
  operation.productSlug?.includes('reimbursement');

export const isReimbursementExpenseOperation = (
  operation: IOperation
): operation is IOperationReimbursementExpense =>
  operation.type === 'benefit_expense' && 'reimbursementOrder' in operation;

export const isTopupOperation = (
  operation: IOperation
): operation is IOperationTopUp => operation.type === 'topup';

export const isVoucherExpenseOperation = (
  operation: IOperation
): operation is IOperationVoucherExpense =>
  operation.type === 'benefit_expense' && 'voucher' in operation;

export const isRefundOperationItem = (operation: IOperationItem) =>
  operation.type === 'refund';

export const isESChildcareOperationItem = (operation: IOperationItem) =>
  operation.categorySlug === 'es-childcare';

export const isESChildcareOperation = (operation: IOperation) =>
  operation.categorySlug === 'es-childcare' && 'childcareVoucher' in operation;

export const isChildcareOperation = (
  operation: IOperation
): operation is IOperationChildcare => 'childcareVoucher' in operation;
